// extracted by mini-css-extract-plugin
export default {"component":"SliderArrows__component--slots-MEOsG","button":"SliderArrows__button--slots-EYwCh","left":"SliderArrows__left--slots-iKWD4","right":"SliderArrows__right--slots-JGoX2"};